enum Color {
  Primary = '#e83f5b',
  Secondary = '#80bcb8',
  Fill = '#f9f9f9',
  FillSecondary = '#efefef',
  Text = '#999',
  Placeholder = '#ccc',
  Error = '#c53030',
  Empty = '#0f0f0f',
  Transparent = 'rgba(255,255,255,0.001)',
}

export default Color;
